import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { EditorialArticleShell, useEditorialNav } from './EditorialArticleShell';
import {
  FEATURE_SLUGS,
  getExamContent,
  getExamHomePath,
  getExamKeyFromHost,
  getExamSiteOrigin,
} from './examContext';

export default function ExamFeaturePage() {
  const { slug } = useParams();
  const examKey = getExamKeyFromHost();
  const { goHome } = useEditorialNav(examKey);
  const contentPack = getExamContent(examKey);
  const content = contentPack.features?.[slug];

  if (!FEATURE_SLUGS.includes(slug) || !content) {
    return <Navigate to={getExamHomePath(examKey)} replace />;
  }

  const examLabel = contentPack.exam || examKey.toUpperCase();
  const title =
    examKey === 'pathbuddy'
      ? `${content.eyebrow || slug} — Pathbuddy`
      : `${content.eyebrow || slug} — IVORI Edu for ${examLabel}`;

  return (
    <EditorialArticleShell
      examKey={examKey}
      title={title}
      description={content.meta}
      url={`${getExamSiteOrigin(examKey)}/features/${slug}`}
      keywords={
        examKey === 'pathbuddy'
          ? 'Pathbuddy, reasoning education, critical thinking, problem solving, grammar school, private school'
          : undefined
      }
      backLabel="← Back to Main"
      onBack={goHome}
      eyebrow={content.eyebrow}
      heading={content.title}
      meta={content.meta}
      bodyHtml={content.body_html}
    />
  );
}
